/**
 * Money stays a **string** through the reference UI — never parsed to a float —
 * so decimal precision survives display, edit and round-trip (matches the
 * backend's DecimalField and the app's cents/decimal-safe rule).
 */

/** A non-negative amount with up to 2 decimal places, e.g. "386" or "1832.50". */
export function isMoney(value: string): boolean {
  return /^\d+(\.\d{1,2})?$/.test(value.trim());
}

/** Format an API decimal string for display (keeps 2 places): "386.00" → "386.00". */
export function displayMoney(value: string): string {
  return value;
}
